// react-client/src/features/feedback/Routes.jsx
import { Route } from 'react-router-dom';
import FeedbackDetailsPage from '../feedback/pages/FeedbackDetailsPage';
import FeedbackSearchPage from '../feedback/pages/FeedbackSearchPage';

export const FeedbackRoutes = () => (
  <Route path="feedback">
    <Route index element={<FeedbackSearchPage />} />
    <Route path="search" element={<FeedbackSearchPage />} />
    <Route
      path=":feedbackId"
      element={<FeedbackDetailsPage />}
    />
  </Route>
);